var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ps-rating"},[_c('i',{staticClass:"fa fa-star"}),_vm._v(" "),_c('i',{staticClass:"fa fa-star"}),_vm._v(" "),_c('i',{staticClass:"fa fa-star"}),_vm._v(" "),_c('i',{staticClass:"fa fa-star"}),_vm._v(" "),_c('i',{staticClass:"fa fa-star-o"})])
}]

export { render, staticRenderFns }